export default "__VITE_ASSET__3ad06451__"